import { PlacesBase } from './api-common.js';
import { BASE_API_URL } from '../envs.js';
export class Sightseeing extends PlacesBase {
    constructor(data) {
        super(data);
        if (typeof data.get === 'function')
            this.url = data.get('url_sightseeing');
        else
            Object.assign(this, data);
    }
}
export async function fetchSightseeings(ids, lang) {
    if (!ids?.length)
        return [];
    const response = await fetch(`${BASE_API_URL}/api/4/feature/sightseeing/${ids.join(',')}?lang=${lang}`);
    return (await response.json()).map((sightseeing) => new Sightseeing(sightseeing));
}
//# sourceMappingURL=api-sightseeings.js.map